export const DEFAULT_BAD_GATEWAY_PAYLOAD = {
  status: 502,
  statusText: 'Bad Gateway',
  message: 'Server is temporarily offline',
};
